import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import Tooltip from '@material-ui/core/Tooltip';
import CircularLoader from '../../../shared/components/CircularLoader/CircularLoader';
import BarChart from '../../../shared/components/BarChart/BarChart';
import { useCallsSummaryData } from '../../hooks/useCallsSummaryData';
import styles from './callSummary.module.scss';

export default memo(function CallSummary(props) {
    const [t] = useTranslation(['dashboard', 'common']);

    useCallsSummaryData(props.getCallsSummaryRequest);

    return (
        <div className={styles.container}>
            <div className={styles.headerContainer}>
                <div className={styles.titleContainer}>
                    <span className={styles.title}>{t('dashboard:calls_summary')}</span>
                    <Tooltip
                        className={styles.tooltip}
                        disableFocusListener
                        disableTouchListener
                        title={t('dashboard:calls_summary_detail')}
                    >
                        <span className={styles.subtitle}>{t('dashboard:calls_summary_detail')}</span>
                    </Tooltip>
                </div>
                {props.summary.fetching && <CircularLoader size={24} />}
                {
                    !props.summary.fetching &&
                    props.summary.error &&
                    props.summary.categories &&
                    props.summary.series &&
                    <Tooltip
                        className={styles.tooltip}
                        disableFocusListener
                        disableTouchListener
                        title={t('dashboard:update_error')}
                    >
                        <div>
                            <SVG cacheGetRequests className={styles.icon} src="./icons/error.svg" />
                        </div>
                    </Tooltip>
                }
            </div>
            {
                props.summary.error &&
                !props.summary.categories &&
                !props.summary.series &&
                <div className={styles.cloudError}>
                    <SVG cacheGetRequests className={styles.icon} src="./icons/cloud_error.svg" />
                    <span>{t('common:no_information_available')}</span>
                </div>
            }
            {
                props.summary.categories &&
                props.summary.series &&
                <div className={styles.informationContainer}>
                    <BarChart
                        categories={props.summary.categories}
                        height={430}
                        maxSum={props.summary.maxSum}
                        series={props.summary.series}
                    />
                </div>
            }
        </div>
    );
}, (prevProps, nextProps) => prevProps.summary === nextProps.summary);
